// 9fbef606107a605d69c0edbcd8029e5d
import LOGOUT_CONSTANTS from '@tcp/core/src/components/features/account/Logout/LogOut.constants';
import { fromJS } from 'immutable';
import MY_PREFERENCE_CONSTANTS from '../MyPreferenceSubscription.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const initialState = {
  subscribeStoreData: null,
  isFetching: false,
  [DEFAULT_REDUCER_KEY]: null,
  showNotification: false,
  error:null
};

const MyPreferenceSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case MY_PREFERENCE_CONSTANTS.GET_SUBSCRIBE_STORE:
      Object.assign({}, state, {
        isFetching: true,
      });

      return { ...state,showNotification:false,error:null };
    case MY_PREFERENCE_CONSTANTS.SET_SUBSCRIBE_STORE:
      Object.assign({}, state, {
        isFetching: false,
      });
      return {
        ...state,
        ...{
          subscribeStoreData: action.payload,
          [DEFAULT_REDUCER_KEY]: setCacheTTL(MY_PREFERENCE_CONSTANTS.GET_SUBSCRIBE_STORE_TTL),
        },
      };
      case MY_PREFERENCE_CONSTANTS.SUBSCRIBE_ERROR:
        return {
          ...state,
          error:fromJS(action.payload),
          showNotification:true
        }
          case MY_PREFERENCE_CONSTANTS.SUBSCRIBE_ERROR_RESET:
            return {
              ...state,
              error:null,
              showNotification:false
            }
    case LOGOUT_CONSTANTS.LOGOUT_APP:
      return { ...initialState };
    default:
      return state;
  }
};

export default MyPreferenceSubscriptionReducer;
